exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes rotation-data-v-2dc0c43a{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}.thumbnail[data-v-2dc0c43a]{border-radius:999em}.thumbnail--placeholder[data-v-2dc0c43a]{display:flex;align-items:center;justify-content:center;background-color:#ffa014;font-size:22px}@media(min-width: 768px){.thumbnail--placeholder[data-v-2dc0c43a]{padding:4px}}@media(max-width: 768px){.thumbnail--placeholder[data-v-2dc0c43a]{padding:9px;border:1px solid #fff}}.thumbnail__icon[data-v-2dc0c43a]{color:#fff}", ""]);

// exports
